import GenericFieldCurrencyComponent from './GenericFieldCurrencyComponent'
export default GenericFieldCurrencyComponent
